import React from 'react'
import { useHistory } from 'react-router-dom'
import classes from './searchcard.module.css'
import { convertToFormatted, getImageURL } from '../../util/functions'
import classNames from 'classnames'
import { DayIndicator } from '../Cards/GeneralCard/CardBadges/CardBadges'
import moment from 'moment'
import Image from '../Image/Image'
import coursePlaceholder from '../../assets/images/course-placeholder.svg'
import classPlaceholder from '../../assets/images/class-placeholder.svg'

const placeholders = {
    course: coursePlaceholder,
    class: classPlaceholder,
}

const SearchCard = ({
    imageUrl,
    title,
    category,
    price,
    lectures,
    downloadable,
    students,
    type,
    date,
    id,
}) => {
    const history = useHistory()

    const handleNavigation = () => {
        if (type === 'class') {
            history.push(`app/browse/classes/${id}`)
        } else {
            history.push(`/app/browse/courses/${id}`)
        }
    }

    return (
        <div
            className={classes.card}
            onClick={handleNavigation}
            style={{ cursor: 'pointer' }}
        >
            {type === 'class' ? (
                <DayIndicator
                    day={moment(date).format('ddd')}
                    dayNumber={moment(date).format('d')}
                    className={classes.cardDate}
                    left
                />
            ) : null}
            <Image
                src={imageUrl ? getImageURL(imageUrl) : placeholders[type]}
                alt="Card Display Image"
                className={classes.cardImage}
                lazyLoad={true}
                errorImageUrl={placeholders[type]}
            />
            <div className={classes.cardText}>
                <div className={classes.cardDetails}>
                    <div className={classes.cardDetailDiv}>
                        <p className={classes.cardTitle}>{title}</p>
                        <p className={classes.cardCategory}>{category}</p>
                    </div>
                    <span className={classes.cardPrice}>
                        {convertToFormatted(price, true, true)}
                    </span>
                </div>
                <div className={classes.cardStats}>
                    {type === 'course' ? (
                        <>
                            <span className={classes.cardStat}>
                                {lectures} lectures
                            </span>
                            <span className={classes.cardStat}>
                                {downloadable} downloadable materials
                            </span>
                            <span className={classes.cardStat}>
                                {students} students enrolled
                            </span>
                        </>
                    ) : (
                        <>
                            <span className={classes.cardStat}>
                                {moment(date).format('ddd, MMM DD, h:mm a')}
                            </span>
                            <span className={classes.cardStat}>
                                {students} students enrolled
                            </span>
                        </>
                    )}
                </div>
                <span
                    className={classNames(
                        classes.cardPrice,
                        classes.cardPriceMobile
                    )}
                >
                    {convertToFormatted(price, true, true)}
                </span>
            </div>
        </div>
    )
}

export default SearchCard
